import { LocalShipping } from '@mui/icons-material'
import LogisticsList from './LogisticsList'
import LogisticsEdit from './LogisticsEdit'
import LogisticsCreate from './LogisticsCreate'

const rentIndex = {
  icon: LocalShipping,
  list: LogisticsList,
  edit: LogisticsEdit,
  create: LogisticsCreate,
}

export default rentIndex
